import React from 'react';
import { FiGithub } from 'react-icons/fi';

import '../styles/project-box.css';

interface projectBoxProps {
    src: string;
    alt: string;
    title: string;
    description: string;
    projectLink: string;
    linkName: string;
    haveLink: boolean;
}

function ProjectBox(props: projectBoxProps) {
    return (
        <div className="project">
            <img src={props.src} alt={props.src} style={{ width: 500 }} />
            <h3>{props.title}</h3>
            <p>{props.description}</p>
            {props.haveLink ?
                <a href={props.projectLink} target="_blank" rel="noopener noreferrer">
                    <FiGithub size={25} color="#000" /><p>{props.linkName}</p>
                </a>
                :
                <p style={{ color: "#00b58e", marginTop: "20px" }}>Esse projeto ou evento não tem link</p>
            }
        </div>
    );
}

export default ProjectBox;